import { render } from "./TextDialog.vue?vue&type=template&id=1c81226f"
import script from "./TextDialog.vue?vue&type=script&lang=js"
export * from "./TextDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__